export default (that) => [
  {
    field: 'seq',
    width: 50,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'displayImage',
    title: that.$l('INDEX.table_label_image') || '图片',
    width: 120,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displayName') || '样品名称',
    field: 'displayName',
    minWidth: 280,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_goodsSizeSpec') || '尺寸颜色',
    field: 'goodsSizeSpec',
    minWidth: 280,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_requestDate') || '报价日期',
    field: 'requestDate',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_requestBy') || '报价人',
    field: 'createByName',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_trackingMethod') || '报价方式',
    field: 'v_trackingMethod',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_trackingCurrencyUnit') || '报价货币单位',
    field: 'v_trackingCurrencyUnit',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fabricContent') || '面料构成',
    field: 'fabricContent',
    minWidth: 280,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_scm') || '成品工厂',
    field: 'scmName',
    minWidth: 280,
    align: 'left',
    showHeaderOverflow: true,
  },
]
